import { mixins } from '@/mixins';

export default {
  name: 'Contact',

  mixins: [ mixins ],

  data() {
    return {}
  },
}
